<template>
  <bottom-sheet
    :visible="visible"
    :close-icon-right-align="true"
    max-width="max-w-[500px]"
    min-height="min-h-[250px]"
    @close="$emit('close')"
  >
    <div class="flex h-full flex-col justify-between px-4">
      <div class="flex flex-col items-center gap-3 md:mt-8">
        <div class="rounded-full bg-red-100 p-4">
          <img
            class=""
            src="@/assets/alert-square-2.svg"
            alt="alert icon"
          />
        </div>

        <div
          v-if="slots.title"
          class="text-base font-normal text-steel-900"
        >
          <slot name="title"></slot>
        </div>
      </div>

      <div class="mb-2 mt-6 flex justify-end gap-2 md:mt-12">
        <ButtonComponent
          class="flex w-1/2 min-w-[75px] justify-center border border-steel-300 md:w-min"
          @click="$emit('close')"
        >
          Cancel
        </ButtonComponent>
        <ButtonComponent
          variant="primary"
          class="flex h-10 w-1/2 !min-w-[75px] justify-center md:w-min"
          :is-loading="isLoading"
          @click="handleSubmit"
        >
          {{ submitText }}
        </ButtonComponent>
      </div>
    </div>
  </bottom-sheet>
</template>

<script setup>
import { useSlots } from 'vue';
import { BottomSheet, ButtonComponent } from '@/components';

defineProps({
  visible: Boolean,
  isLoading: Boolean,
  submitText: {
    type: String,
    default: 'Yes',
  },
});

const emit = defineEmits(['close', 'submit']);
const slots = useSlots();

const handleSubmit = () => {
  emit('submit');
};
</script>
